import React, { useState } from 'react';

// mui
import { Button, Container, Icon, IconButton, InputAdornment, Stack, TextField, Typography } from '@mui/material';

// icons
import SaveRoundedIcon from '@mui/icons-material/SaveRounded';
import FaceRoundedIcon from '@mui/icons-material/FaceRounded';

import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import { useForm } from 'react-hook-form';
import { useAuth } from '../hooks/useAuth';
import { useAlert } from '../hooks/useAlert';

// components
import Iconify from '../components/iconify/Iconify';

const userSchema = yup.object().shape({
  name: yup.string().required('Meno je povinné'),
  email: yup.string().email('Neplatný email').required('E-mail je povinný'),
  password: yup
    .string()
    .required('Pre zmenu údajov musíte vždy zadať aktuálne heslo.')
    .min(6, 'Heslo musí obsahovať minimálne 6 znakov'),
  newPassword: yup.string().min(6, 'Name must be at least 6 characters'),
});

const Profile = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);

  const { user, editUser, setUser } = useAuth();
  const { success, error, confirm } = useAlert();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(userSchema) });

  const onSubmit = async (data) => {
    const result = await confirm('Potvrďte zmeny', 'Uložiť');
    if (result?.isConfirmed) {
      if (data) {
        try {
          await editUser(user.id, data);
          setUser(data);
          success('Vaše údaje boli zmenené');
        } catch (err) {
          error('Zadali ste nesprávne heslo.');
        }
      } else {
        error('Nepodarilo sa uložiť vaše informacie.');
      }
    }
  };

  return (
    <Container maxWidth="sm">
      <Typography variant="h3" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
        <FaceRoundedIcon sx={{ mr: 1, fontSize: 40 }} />
        Váš profil
      </Typography>
      <Stack sx={{ mb: 5, mt: 2, maxWidth: 500 }}>
        <TextField
          sx={{ mb: 3 }}
          id="name"
          type="text"
          label="Vaše meno"
          name="name"
          variant="outlined"
          defaultValue={user.name}
          error={errors.name}
          helperText={errors.name?.message}
          onChange={() => console.log(errors)}
          {...register('name')}
        />
        <TextField
          sx={{ mb: 1 }}
          id="mail"
          type="mail"
          label="E-mail"
          name="mail"
          defaultValue={user.email}
          variant="outlined"
          error={errors.email}
          helperText={errors.email?.message}
          {...register('email')}
        />
        <TextField
          id="password"
          label="Heslo"
          type={!showPassword ? 'password' : 'text'}
          name="password"
          variant="outlined"
          error={errors.password}
          helperText={errors.password?.message}
          {...register('password')}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword((prev) => !prev)} edge="end">
                  <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Stack>
      <Typography variant="h5" gutterBottom>
        Nové údaje
      </Typography>
      <Stack sx={{ mt: 2, maxWidth: 500 }}>
        <TextField
          type={!showNewPassword ? 'password' : 'text'}
          id="new-password"
          label="Nové heslo"
          name="new-password"
          variant="outlined"
          error={errors.newPassword}
          helperText={errors.newPassword?.message}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowNewPassword((prev) => !prev)} edge="end">
                  <Iconify icon={showNewPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <Button onClick={handleSubmit(onSubmit)} variant="contained" sx={{ mt: 2 }} startIcon={<SaveRoundedIcon />}>
          Uložiť
        </Button>
      </Stack>
    </Container>
  );
};

export default Profile;
